import { render, staticRenderFns } from "./CnSafetyDetail.vue?vue&type=template&id=28c30510&scoped=true&"
import script from "./CnSafetyDetail.vue?vue&type=script&lang=js&"
export * from "./CnSafetyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CnSafetyDetail.vue?vue&type=style&index=0&id=28c30510&prod&lang=scss&scoped=true&"
import style1 from "./CnSafetyDetail.vue?vue&type=style&index=1&id=28c30510&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c30510",
  null
  
)

export default component.exports